export default __webpack_public_path__ + "static/media/dragon-food.d990b20f.jpg";